import React, { Component } from "react";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import ProductHeader from "../ProductDetails/ProductHeader";
import { GetApp, Height, DesktopWindowsSharp } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import DownloadFailed from "./DownloadFailed";
import ActionButton from "../ActionButton";
import { CircularProgress } from "@material-ui/core";
export class index extends Component {
  made_request = false;
  state = {
    data: [],
  };
  async componentDidMount() {
    const trackingCode = this.props.match.params.tracking_id;
    let request = await instance.get(`/get_download/${trackingCode}`);
    this.made_request = true;
    this.setState({ data: request.data });
  }
  render() {
    if (!this.props.match.params.tracking_id) this.props.history.replace("/");

    let host = "/"; // change later
    const trackingCode = this.props.match.params.tracking_id;
    const language = this.props.language;

    let items = [];
    if (this.state.data.length) {
      items = this.state.data.map((item) => (
        <div
          style={{ width: "90%", minHeight: 50 }}
          className={`row mt-5 mx-auto   ${
            language === "english" ? "" : "  flex-row-reverse"
          }`}
        >
          <div
            className="col"
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              direction: language === "english" ? "ltr" : "rtl",
            }}
          >
            {language === "english"
              ? item.product_name_english
              : item.product_name_arabic}
          </div>
          <div
            className="col"
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              direction: language === "english" ? "ltr" : "rtl",
            }}
          >
            {language === "english" ? item.name_english : item.name_arabic}
          </div>
          <div
            className="col "
            style={{ position: "relative", bottom: "10px" }}
          >
            <a
              href={`${window.location.origin}/downloads/${trackingCode}/file/${item.file}/`}
              target="_blank"
              download
            >
              <Button variant="contained" color="primary" size="small">
                <GetApp />
              </Button>
            </a>
          </div>
        </div>
      ));
    }

    return (
      <div
        style={{
          backgroundColor: "white",
        }}
      >
        <ProductHeader
          title={language == "english" ? "Downloads" : "الملفات"}
          onBack={() =>
            this.props.history.location.state &&
            this.props.history.location.state.fromTracking
              ? this.props.history.goBack()
              : this.props.history.replace("/")
          }
        />
        <div
          className="free-space-115"
          style={{ backgroundColor: "white" }}
        ></div>
        {this.made_request ? (
          items.length ? (
            <div className="">
              <div
                style={{ width: "90%" }}
                className={`row mx-auto    ${
                  language === "english" ? "" : " flex-row-reverse"
                }`}
              >
                <div className=" col">
                  {language === "english" ? "Product" : "المنتج"}
                </div>
                <div className=" col">
                  {" "}
                  {language === "english" ? "File" : "الملف"}
                </div>
                <div className=" col ">
                  {" "}
                  {language === "english" ? "Download" : "تحميل"}
                </div>
              </div>
              {items}
            </div>
          ) : (
            <DownloadFailed />
          )
        ) : (
          <CircularProgress color="primary" style={{ marginTop: 20 }} />
        )}
        <div className="free-space-80-white"></div>
        <ActionButton
          action={
            language == "english"
              ? "Back to shopping"
              : "العودة الى القائمة الرئيسية"
          }
          onClick={() => this.props.history.replace("/")}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.store.language,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(index);
